import { createContext, useContext } from 'react'
import type { Project } from '@/lib/api/types'

export interface ProjectContextValue {
  project: Project | null
  userRole: string
  projectId: string
  isLoading: boolean
}

export const ProjectContext = createContext<ProjectContextValue>({
  project: null,
  userRole: 'worker',
  projectId: '',
  isLoading: true,
})

export function useProjectContext() {
  return useContext(ProjectContext)
}
